<script setup>
import { ref, computed } from 'vue'

const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS
const rango = ref(50)
const posicion = computed(() => `${rango.value - 100}%`)

defineProps({
  descripcion: {
    type: String,
    default: 'Descripcion de la comparativa',
  },
  comparativa: {
    type: Array,
    default: () => [
      {
        imagen:
          'https://cdn.conahcyt.mx/sisdai/recursos/imagenes/documentacion/petunia-1.jpg',
        titulo_tarjeta: 'Tarjeta Petunia',
        parrafo_inicio: '<p>Contenido de ejemplo, tarjeta Kiara</p>',
        enlace_descarga: '#',
        nombre_descarga: 'DescargaPetunia',
      },
      {
        imagen:
          'https://cdn.conahcyt.mx/sisdai/recursos/imagenes/documentacion/planta.jpg',
        titulo_tarjeta: 'Tarjeta Planta',
        parrafo_inicio:
          '<p>Contenido de ejemplo, tarjeta dos</p><p>Contenido de ejemplo, tarjeta dos</p>',
        enlace_descarga: '#',
        nombre_descarga: 'DescargaPlanta',
      },
    ],
  },
})
</script>
<template>
  <div
    class="control-deslizante-contenido borde-redondeado-24 m-y-3"
    role="figure"
    :aria-label="descripcion"
  >
    <div class="control-deslizante-contenido-tarjeta tarjeta">
      <img
        class="tarjeta-imagen"
        :src="`${cdnArchivos}/${comparativa[0].imagen}`"
        alt=""
        height="240"
      />
      <div class="tarjeta-cuerpo">
        <p class="tarjeta-titulo">{{ comparativa[0].titulo_tarjeta }}</p>
        <div v-html="comparativa[0].parrafo_inicio"></div>
      </div>
      <div class="tarjeta-pie">
        <a
          v-if="!comparativa[0].nombre_descarga.includes('11.1')"
          class="boton boton-primario boton-chico"
          :href="`${cdnArchivos}/${comparativa[0].enlace_descarga}`"
          target="_blank"
          download
        >
          {{ comparativa[0].nombre_descarga }}
          <span
            class="pictograma-archivo-descargar"
            aria-hidden="true"
          ></span>
        </a>
      </div>
    </div>

    <div>
      <input
        type="range"
        min="0"
        max="100"
        v-model="rango"
        class="control-deslizante-contenido-control"
      />
    </div>

    <div class="control-deslizante-contenido-tarjeta tarjeta">
      <img
        class="tarjeta-imagen"
        :src="`${cdnArchivos}/${comparativa[1].imagen}`"
        alt=""
        height="240"
      />
      <div class="tarjeta-cuerpo">
        <p class="tarjeta-titulo">{{ comparativa[1].titulo_tarjeta }}</p>
        <div v-html="comparativa[1].parrafo_inicio"></div>
      </div>
      <div class="tarjeta-pie">
        <a
          class="boton boton-primario boton-chico"
          :href="`${cdnArchivos}/${comparativa[1].enlace_descarga}`"
          target="_blank"
          download
        >
          {{ comparativa[1].nombre_descarga }}
          <span
            class="pictograma-archivo-descargar"
            aria-hidden="true"
          ></span>
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.control-deslizante-contenido-tarjeta:not(:first-of-type) {
  transform: translateX(v-bind(posicion));
}

.control-deslizante-contenido {
  display: flex;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
  max-width: 624px;
  margin-left: auto;
  margin-right: auto;
}

.control-deslizante-contenido-tarjeta {
  &.tarjeta {
    height: auto;
  }
  flex: 1 0 100%;
  .tarjeta-imagen {
    height: 240px;
    object-fit: cover;
    object-position: 0;
  }
  &:first-of-type {
    z-index: 2;
  }
  &:not(:first-of-type) {
    z-index: 3;
    background-color: var(--fondo-acento);
    box-shadow:
      inset 4px 0 0 var(--boton-primario-fondo),
      -4px 0 0 var(--boton-primario-fondo),
      -8px 0 24px var(--opacidad-ligero);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    .tarjeta-imagen {
      padding-left: 4px;
    }
  }
}

[type='range'].control-deslizante-contenido-control {
  --thumb-size: 40px;
  position: absolute;
  left: calc(var(--thumb-size) * -0.5);
  right: calc(var(--thumb-size) * -0.5);
  top: calc(50% - 20px);
  z-index: 4;
  width: calc(100% + var(--thumb-size));
  height: var(--thumb-size);
  background: transparent;
  border: none;
  box-shadow: none;
  cursor: default;
  // bolita
  &::-moz-range-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    cursor: col-resize;
    background-color: var(--boton-primario-fondo);
    background-image: url('data:image/svg+xml;utf8,<svg viewbox="0 0 40 40"  width="40" height="40" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="white" stroke-width="2" d="M15 13 L8 20 L15 27"/><path fill="none" stroke="white" stroke-width="2" d="M25 13 L32 20 L25 27"/></svg>');
    transition:
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      box-shadow 0.3s ease-in-out;
  }
  &::-ms-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    cursor: col-resize;
    background-color: var(--boton-primario-fondo);
    transition:
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      box-shadow 0.3s ease-in-out;
  }
  &::-webkit-slider-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    cursor: col-resize;
    background-color: var(--boton-primario-fondo);
    transition:
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      box-shadow 0.3s ease-in-out;
  }
  // linea
  &::-webkit-slider-runnable-track {
    background-color: transparent;
  }
  &::-moz-range-track {
    background-color: transparent;
  }
  &::-ms-fill-lower {
    background-color: transparent;
  }
  &::-ms-fill-upper {
    background-color: transparent;
  }

  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background: transparent;
    border: none;
    box-shadow: none;
    // bolita
    &::-moz-range-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
    }
    &::-ms-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
    }
    &::-webkit-slider-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
    }
    // linea
    &::-webkit-slider-runnable-track {
      background-color: transparent;
    }
    &::-moz-range-track {
      background-color: transparent;
    }
    &::-ms-fill-lower {
      background-color: transparent;
    }
    &::-ms-fill-upper {
      background-color: transparent;
    }
  }

  &:not(:disabled):focus {
    background: transparent;
    border: none;
    box-shadow: none;
    // bolita
    &::-moz-range-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
      box-shadow:
        inset 0 0 0 1px var(--boton-primario-enfoque-borde),
        0 0 0 1px var(--boton-primario-enfoque-contorno),
        0 0 18px var(--boton-primario-enfoque-sombra);
    }
    &::-ms-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
      box-shadow:
        inset 0 0 0 1px var(--boton-primario-enfoque-borde),
        0 0 0 1px var(--boton-primario-enfoque-contorno),
        0 0 18px var(--boton-primario-enfoque-sombra);
    }
    &::-webkit-slider-thumb {
      background-color: var(--boton-primario-enfoque-fondo);
      box-shadow:
        inset 0 0 0 1px var(--boton-primario-enfoque-borde),
        0 0 0 1px var(--boton-primario-enfoque-contorno),
        0 0 18px var(--boton-primario-enfoque-sombra);
    }
    // linea
    &::-webkit-slider-runnable-track {
      background-color: transparent;
    }
    &::-moz-range-track {
      background-color: transparent;
    }
    &::-ms-fill-lower {
      background-color: transparent;
    }
    &::-ms-fill-upper {
      background-color: transparent;
    }
  }
}

.a11y-simplificada {
  .control-deslizante-contenido {
    gap: 16px;
    @include mediaquery('mov') {
      flex-direction: column;
      gap: 8px;
    }
  }
  .control-deslizante-contenido-tarjeta {
    height: auto;
    flex: 1 1 50%;
    border-radius: 16px;
    box-shadow: none;
    &:not(:first-of-type) {
      transform: translateX(0);
    }
    .tarjeta-cuerpo {
      background: inherit;
      color: inherit;
    }
  }
  .control-deslizante-contenido-control {
    display: none;
  }
}
</style>
